import {Api, decryptApiResponse} from "../../../../config/Api";
import {statusAndResponse} from "../../../../util/requestHandler";

export function getAllCredentials() {
  return statusAndResponse(
    Api.get('/api/client/credentials/list'),
    decryptApiResponse
  )
}